export default "/images/9afd3247bc117929d351d58949990055.avif";